export default {"src":"/_next/static/media/welcome.e14bf6d4.webp","height":512,"width":512,"blurWidth":0,"blurHeight":0};